// eventsData.js
const eventsData = [
  {
    title: 'Hackathon',
    start: new Date(2024, 8, 20, 9, 0),
    end: new Date(2024, 8, 20, 18, 0),
    location: 'Conference Hall, Building A',
  },
  {
    title: 'SWE @ Morgan Stanley',
    start: new Date(2024, 8, 16, 0, 0), // Sept 16th
    end: new Date(2024, 8, 16, 23, 59),
    location: 'Morgan Stanley Office',
  },
  {
    title: 'SWE @ Google',
    start: new Date(2024, 8, 30, 0, 0), // Sept 30th
    end: new Date(2024, 8, 30, 23, 59),
    location: 'Google Campus',
  },
  {
    title: 'Quant Intern @ Citadel',
    start: new Date(2024, 9, 14, 0, 0), // Oct 14th
    end: new Date(2024, 9, 14, 23, 59),
    location: 'Citadel Office',
  },
  {
    title: 'GBM #1', 
    start: new Date(2025, 0, 16, 0, 0), // Jan 14th
    end: new Date(2025, 0, 16, 23, 59),
    location: 'MLC 268',
  },
  {
    title: 'Engagement Fair', 
    start: new Date(2025, 0, 29, 18, 30), // Jan 29th
    end: new Date(2025, 0, 29, 22, 0), 
    location: 'Tate Student Center'
  },
  {
    title: 'ACM Collaboration',
    start: new Date(2025, 0, 30, 18, 30), // Jan 30th
    end: new Date(2025, 0, 30, 19, 30), 
    location: 'Boyd 322'
  }, 
  {
    title: 'GBM #2',
    start: new Date(2025, 1, 4, 0, 0), // Feb 4th
    end: new Date(2025, 1, 4, 23, 59),
    location: 'Boyd 208'
  },
  {
    title: 'GBM #3',
    start: new Date(2025, 1, 18, 18, 0), // Feb 18th
    end: new Date(2025, 1, 18, 19, 0),
    location: 'Boyd 208 from 6-7'
  },
  {
    title: 'Economics Society: AI Panel',
    start: new Date(2025, 1, 17, 17, 30), 
    end: new Date(2025, 1, 17, 19, 0),
    location: ''
  },
  {
    title: 'Frazier & Deeter',
    start: new Date(2025, 1, 18, 9, 0), 
    end: new Date(2025, 1, 18, 23, 0),
    location: ''
  },
  {
    title: 'Bank of America',
    start: new Date(2025, 1, 18, 9, 0), 
    end: new Date(2025, 1, 18, 23, 0),
    location: ''
  },
];

export default eventsData;
